
export const GLOBAL = Object.freeze({
    BASE_PATH: '/maxstorage',
});


// WEBPACK FOOTER //
// /app/src/globals.ts